import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {OrderPreviewTablesModule} from '../order-preview/order-preview-tables.module';
import { AgGridModule } from 'ag-grid-angular';
import { AngularSplitModule } from 'angular-split';
import { DevExtremeModule } from '../devextreme.module';
import { EtsCommonModule } from '../common-services/common.module';
import { GenericConfirmationDialogModule } from '../generic-confirmation-dialog/generic-confirmation-dialog.module';
import { EtsSymbolPickerModule } from '../symbol-picker/symbol-picker.module';
import { ExpirationSelectorModule } from '../expiration-selector/expiration-selector.module';
import { OptionsCommonModule } from '../options-common/options-common.module';
import { DateTimePickerModule } from '../datetime-picker/datetime-picker.module';
import { CollarsComponent } from './collars.component';
import { CollarsBackdateDialogComponent } from './backdate/collars-backdate-dialog.component';
import { CollarsMakeTransactionDialogComponent } from './after-state/collars-make-transaction-dialog.component';
import { CollarsApplyAfterStateDialogComponent } from './after-state/collars-apply-after-state-dialog.component';
import { CollarsAcquireDialogComponent } from './after-state/collars-acquire-dialog.component';
import { PhaExportDialogModule } from '../portfolio-hedging-analysis/pha-export-dialog.module';
import { CollarsAfterStatePreviewComponent } from './after-state/collars-after-state-preview.component';
import { CollarsAfterStateService } from './after-state/collars-after-state.service';
import { CollarsTransactionDiffService } from './after-state/collars-transaction-diff.service';
import { CollarsComboSettingsService } from './collars-combo-settings.service';
import { CollarsQgCursorService } from './collars-qg-cursor.service';
import { CollarsAnalysisLockService } from './collars-analysis-lock.service';
import { CopyOrdersToService } from '../adjustment-pricing-grid/services/copy-orders-to.service';
import { CollarsQtyToMarketSidePipe } from './collars-qty-to-side.pipe';

@NgModule({
   imports: [
        OrderPreviewTablesModule,
      CommonModule,
      AgGridModule.withComponents([]),
      AngularSplitModule,
      DevExtremeModule,
      // EtsCommonModule exports the 'etsFriendlyDatePipe' (FriendlyDatePipe) the cloned after-state tables use
      // for the Expiration column. NOTE: 'etsQtyToMarketSide' is NOT exported by any non-HG module, so Collars
      // declares its OWN CollarsQtyToMarketSidePipe (same template name) below — Collars never imports HG.
      EtsCommonModule,
      GenericConfirmationDialogModule,
      EtsSymbolPickerModule,
      ExpirationSelectorModule,
      OptionsCommonModule,
      DateTimePickerModule,
      // The Analysis panel's Export window, reused in its ACQUIRE mode for the analysis order blocks
      // (CR-20260930-001 M3, owner 2026-09-30: same window, plus a fill box per leg and an Acquire button).
      PhaExportDialogModule
   ],
   declarations: [
      CollarsComponent,
      CollarsBackdateDialogComponent,
      CollarsMakeTransactionDialogComponent,
      CollarsApplyAfterStateDialogComponent,
      CollarsAcquireDialogComponent,
      CollarsAfterStatePreviewComponent,
      // Local clone of HG's 'etsQtyToMarketSide' pipe (Side column on the cloned after-state tables).
      CollarsQtyToMarketSidePipe
   ],
   providers: [
      CollarsAfterStateService,
      // The analysis design-lock reader (CR-20260930-001): asks the Shell which combos are under analysis so
      // the panel can say WHY a design action is refused (a refused command carries no text over WCF).
      CollarsAnalysisLockService,
      CollarsTransactionDiffService,
      // Combo settings reader (backend bucket row, CR-20260611-001) — the Make-Transaction totals normalizer.
      CollarsComboSettingsService,
      // QG cursor reader: the "now" the panel's/dialogs' "(Nd)" DTE counts from in QG history mode.
      CollarsQgCursorService,
      // Enables Copy-to-TOS in the Make-Transaction dialog. @Injectable() (NOT providedIn root), provided
      // per-feature-module (same pattern as package-comparison.module.ts). Its ctor deps (ClipboardService,
      // SettingsStorageService) are both providedIn:'root', so this provider DI-verifies. Without it the
      // dialog's @Optional() injection resolves null and onCopyToTos degrades to a toast.
      CopyOrdersToService
   ],
   exports: [CollarsComponent]
})
export class EtsCollarsModule { }
